import { Trophy } from 'lucide-react';
import { createWebRegistrationFromManifest } from '@reflex/plugin-api/create-web-registration';
import { leaderboardWeb } from '../web-manifest.js';

export default createWebRegistrationFromManifest(
  leaderboardWeb,
  {
    LeaderboardPage: () => import('./LeaderboardPage'),
    LeaderboardPagePreview: () => import('./LeaderboardPagePreview'),
  },
  {
    icons: { Trophy },
  },
);
